module.exports = new __parcel__URL__("shop_machines_bench_press.cfa2d745.png").toString();